import React from "react";

/**
 * Icônes du design SIP Stock (jeu de traits 24x24, `currentColor`).
 * `size` et `color` couvrent les rares cas où l'icône n'hérite pas de la couleur
 * du texte (icônes d'accent des cartes de stock, titres de scan).
 */
const base = (size, color, strokeWidth) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color || "currentColor",
  strokeWidth: strokeWidth || 2,
});

export const IconBox = ({ size = 22, color }) => (
  <svg {...base(size, color)}>
    <path d="M20 7L12 3 4 7v10l8 4 8-4V7z" />
    <path d="M4 7l8 4 8-4" />
    <path d="M12 21V11" />
  </svg>
);

export const IconLock = ({ size = 22, color }) => (
  <svg {...base(size, color)}>
    <rect x="3" y="11" width="18" height="10" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const IconEntree = ({ size = 22, color }) => (
  <svg {...base(size, color)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export const IconSortie = ({ size = 22, color }) => (
  <svg {...base(size, color)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

export const IconHome = ({ size = 21, color }) => (
  <svg {...base(size, color)}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export const IconClipboard = ({ size = 21, color }) => (
  <svg {...base(size, color)}>
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <line x1="8" y1="12" x2="16" y2="12" />
    <line x1="8" y1="16" x2="16" y2="16" />
  </svg>
);

export const IconChevronLeft = ({ size = 15, color }) => (
  <svg {...base(size, color, 2.4)}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const IconPlus = ({ size = 16, color }) => (
  <svg {...base(size, color, 2.6)}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconPlay = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

export const IconWarning = ({ size = 16, color }) => (
  <svg {...base(size, color, 2.2)}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const IconWifiOff = ({ size = 15, color }) => (
  <svg {...base(size, color, 2.2)} strokeLinecap="round">
    <line x1="1" y1="1" x2="23" y2="23" />
    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
    <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
    <line x1="12" y1="20" x2="12.01" y2="20" />
  </svg>
);

export const IconMoon = ({ size = 17, color }) => (
  <svg {...base(size, color)}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export const IconSun = ({ size = 17, color }) => (
  <svg {...base(size, color)}>
    <circle cx="12" cy="12" r="4.5" />
    <line x1="12" y1="1.5" x2="12" y2="4" />
    <line x1="12" y1="20" x2="12" y2="22.5" />
    <line x1="4" y1="12" x2="1.5" y2="12" />
    <line x1="22.5" y1="12" x2="20" y2="12" />
    <line x1="4.9" y1="4.9" x2="6.5" y2="6.5" />
    <line x1="17.5" y1="17.5" x2="19.1" y2="19.1" />
    <line x1="4.9" y1="19.1" x2="6.5" y2="17.5" />
    <line x1="17.5" y1="6.5" x2="19.1" y2="4.9" />
  </svg>
);
